var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-avatar',{attrs:{"src":_vm.userPhoto}},[_c('img',{attrs:{"src":_vm.userPhoto}})])}
var staticRenderFns = []

export { render, staticRenderFns }